import { defineComponent as _defineComponent } from 'vue'
import { computed, onBeforeUnmount, onMounted, ref } from 'vue';

type Placement = 'left' | 'center' | 'right';


export default /*#__PURE__*/_defineComponent({
  __name: 'PopoverModal',
  props: {
    cssClass: null,
    boundingElement: null,
    anchor: { default: 'center' },
    position: { default: 'center' },
    bottomGutter: { default: 5 }
  },
  setup(__props: any) {

const props = __props as { cssClass?: any, boundingElement?: HTMLElement, anchor: Placement, position: Placement, bottomGutter: number };



const popover = ref<HTMLElement | null>(null);
const popoverWidth = ref(0);

onMounted(() => {
	if (!popover.value) return;

	const observer = new ResizeObserver(() => {
		if (popover.value) popoverWidth.value = popover.value.offsetWidth;
	});

	observer.observe(popover.value);

	onBeforeUnmount(() => observer.disconnect());
});

const style = computed(() => {
	if (!props.boundingElement || !popover.value) return {};

	let data = {};
	let anchorX = 0;

	const rect = props.boundingElement.getBoundingClientRect();
	switch (props.anchor) {
		case 'left':
			anchorX = rect.left;
			break;
		case 'right':
			anchorX = rect.left + rect.width;
			break;
		default:
			anchorX = rect.left + rect.width / 2;
			break;
	}

	if (popoverWidth.value >= window.innerWidth) {
		data = { left: '0px', right: '0px' };
	}

	let left: number;

	switch (props.position) {
		case 'left':
			left = anchorX;
			break;
		case 'right':
			left = anchorX - popoverWidth.value;
			break;
		default:
			left = anchorX - popoverWidth.value / 2;
			break;
	}

	if (left < 0) {
		data = { left: '0px' };
	} else if (left + popoverWidth.value > window.innerWidth) {
		data = { right: '0px' };
	} else {
		data = { left: `${left}px` };
	}

	return {
		...data,
		top: `${rect.bottom + props.bottomGutter}px`,
	};
});

return { __sfc: true,props, popover, popoverWidth, style }
}

})